import Vue from "vue";
import generateMixin from "../shared/Genmixin";
export default Vue.mixin(generateMixin("deposits"));